// extracted by mini-css-extract-plugin
export default {"componentToast":"Toast_componentToast__0ha+5","body":"Toast_body__wpJM9"};